module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "image0",
    attrs: {
      "id": "ch-2"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/15-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter-no"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/d2.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_c('h1', {
    staticClass: "chapter-title-gr"
  }, [_vm._v("Cracks in the Foundation?")]), _vm._v(" "), _c('p', {
    staticClass: "epigraph"
  }, [_c('em', [_vm._v("They are like a man building a house, who dug down deep and laid the foundation on rock. When a flood came, the torrent struck that house but could not shake it, because it was well built.")])]), _vm._v(" "), _c('p', {
    staticClass: "epigraph-author"
  }, [_vm._v("L"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("UKE")]), _vm._v(" 6:48")]), _vm._v(" "), _c('p', {
    staticClass: "line-image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/line2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "d-para"
  }, [_c('span', {
    staticClass: "drop-cap"
  }, [_c('span', {
    staticClass: "brwn"
  }, [_vm._v("I")])]), _vm._v("n 2017 we moved from our ranch in the very dry, extremely windy Abilene, Texas, to our Houston house just in time for Hurricane Harvey. We love Houston. And before you guffaw, let me tell you, Houston is fabulous. If you have never been and have only seen photos, you might be thinking, "), _c('em', [_vm._v("Doesn’t all of Texas just look like an episode of the Road Runner cartoon, with an occasional motor home and random skyscraper?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("No, Wile E. Coyote, it does not.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We live in a forest of towering pines on a huge lake. I have never seen such remarkable skies. The clouds remind me of explosive mountains, constantly morphing. We are minutes from some of the finest dining in the world, as well as great shopping, shows, and museums. We are an hour from the beach and forty-five minutes from some of the most fantastic camping to be found.")]), _vm._v(" "), _c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/15-2.jpg"
    }
  })])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_15"
    }
  }, [_vm._v("As I compose this, ")]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("it is six days until Christmas, and it is sixty degrees and sunny. The projected forecast for Christmas Day is a crisp fifty-two degrees. Sophie, our youngest daughter, flew in from New York yesterday. Luke, our third oldest, will fly home from Hawaii on Christmas Eve. This means all four of our eldest children and their spouses will be joining Justin, me, and our two youngest boys, Sam and Charlie, for Christmas. I am one happy girl.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "alt": "Image",
      "src": "images/16.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Still, no matter how fragrant my descriptions, you might be thinking, "), _c('em', [_vm._v("I need a white Christmas")]), _vm._v(". Or "), _c('em', [_vm._v("She failed to mention Houston’s rumored standstill traffic or the 599 percent humidity or the stifling 110 degree August afternoons")]), _vm._v(". And I have my responses, but I am not here to convince you to move to Texas.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("I am just here to point out that you are you. Your foundation is not my foundation. My beliefs are no threat to your beliefs, and yours are no threat to mine. If you despise all things Lone Star State, I can still love it. My bumper sticker may command you not to mess with my state, but I am too busy to do anything about it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Just like I’m not worried whether or not you love Texas, Jesus isn’t threatened by your doubts or concerns. He can’t be deconstructed. You don’t need to try to figure out whether or not he’ll come through.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("His nature was confirmed when he died on the cross and then rose again. Unlike your preference for places other than Texas, who he is is fact.")])]), _c('p', {
    staticClass: "indent-para"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("If we’re struggling with Jesus, it’s because we’re dealing with misunderstandings, and we have foundation work we need to attend to.")])]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_c('p', {
    staticClass: "indent-para"
  }, [_vm._v("With any renovation, we must first make sure the structure is secure before we do anything else. After we get the underbelly cleaned up, we rebuild the way the structure functions on the seamless, crack-free foundation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We have to teach the subconscious, or what I call the heart-head, how to trust something new. We can say that Jesus is our strong foundation. But years of difficult real-life experience combined with limiting beliefs and questions about God have the heart-head desperate to truly believe something but struggling to. Our rehearsed words about lack, want, and suffering have taught our minds to disbelieve Jesus’s faithfulness.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("We have so much information and experience that bury truth, like debris crusted over old wood flooring. But if we scrape those floors, if we acknowledge and dig for proof of Jesus’s claims that he is our good helper, we will see for ourselves that God is indeed our strong foundation, and we can build something new from there.")]), _vm._v(" "), _c('p', {
    staticClass: "indent-para"
  }, [_vm._v("Today I invite you to write out a list of things that you know are true of God. Now "), _c('em', [_vm._v("choose")]), _vm._v(" to actively feel and believe these promises. Write out today’s Scripture (or another that talks about God’s plan for you). Feel the sturdiness of the words, and rest in the comfort of being seen, heard, and known.")]), _vm._v(" "), _c('div', {
    staticClass: "box-o"
  }, [_c('h1', {
    staticClass: "box-title"
  }, [_c('strong', [_vm._v("THE FINISHING TOUCH")])]), _vm._v(" "), _c('p', {
    staticClass: "box-para"
  }, [_vm._v("Jesus, I want to truly know and experience you. Open my eyes to who you truly are, and help me enjoy your peace and abundance from the ground up! Amen.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9b2ebf32","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/009_Chapter02.vue
// module id = 81
// module chunks = 0